/* eslint-disable */
var Big = require('big.js');
import moment from 'moment';
import { EVENT_LEVELS, PRODUCTS_STATE, SORT_TYPES } from '@/containers/utils/constant.js';
import { constant } from '@/utils/constant.js';
import i18n from '@/i18n';
import { get } from 'lodash';
const $t = (text) => {
  return i18n.global.t(text);
};

const FILE = {
  UNITS: ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'],
  BASE_VALUE: Array(6).fill(1024)
};
const TIME = {
  UNITS: ['usec', 'ms', 'sec', 'min', 'hour', 'day'],
  BASE_VALUE: [1000, 1000, 60, 60, 24, 1]
};
const NON_CONVERTIBLE_UNITS = ['%'];
const NUMBER = {
  UNITS: ['', 'K', 'M', 'G', 'T', 'P'],
  BASE_VALUE: Array(6).fill(1000)
};

const PRODUCTS_STATE_COLORS = {
  [PRODUCTS_STATE.RUNNING]: '#23D79E',
  [PRODUCTS_STATE.READY]: '#23D79E',
  [PRODUCTS_STATE.DOWN]: '#FB4B57',
  [PRODUCTS_STATE.NOT_READY]: '#FB4B57',
  [PRODUCTS_STATE.NE]: '#A386EF',
  [PRODUCTS_STATE.DELETING]: '#CFD2D8',
  [PRODUCTS_STATE.RESIZING]: '#CFD2D8'
};

const PERIOD_UNITS = {
  m: 'minutes',
  h: 'hours',
  d: 'days'
};

export const ACTION_EVENT = {
  FIND_TEMPLATE: 'FIND_TEMPLATE'
};

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};

const tzDefault = 'Africa/Abidjan';
export const scpmUtil = {
  generateRandomKey() {
    return Math.random().toString(36).substring(2);
  },
  convertToCamelCase(obj) {
    if (Array.isArray(obj)) return obj.map((el) => this.convertToCamelCase(el));
    if (!(obj instanceof Object)) return obj;
    const camelCaseObj = {};
    for (const prop in obj) {
      const segments = prop.split('_');
      const camelCaseProp = [
        segments[0],
        ...segments.slice(1).map((e) => e[0].toUpperCase() + e.substring(1))
      ].join('');
      camelCaseObj[camelCaseProp] = this.convertToCamelCase(obj[prop]);
    }
    return camelCaseObj;
  },

  isUnitAbleToConvert(unit) {
    return [FILE.UNITS, TIME.UNITS].some((item) => item.includes(unit));
  },
  getUnitBaseType(unit) {
    if (FILE.UNITS.includes(unit))
      return { type: 'file', units: FILE.UNITS, baseValue: FILE.BASE_VALUE };
    if (TIME.UNITS.includes(unit))
      return { type: 'time', units: TIME.UNITS, baseValue: TIME.BASE_VALUE };
    if (NUMBER.UNITS.includes(unit))
      return { type: 'number', units: NUMBER.UNITS, baseValue: NUMBER.BASE_VALUE };
    throw Error('Unit is not supported to convert');
  },
  convertToSpecificUnit(value, unit, toUnit) {
    const { units, baseValue: baseVal } = this.getUnitBaseType(unit);
    if (!units.includes(toUnit)) throw Error('Converted unit is not valid');
    const curIdx = units.indexOf(unit);
    const toIdx = units.indexOf(toUnit);
    const accumulate = curIdx < toIdx ? baseVal.slice(curIdx, toIdx) : baseVal.slice(toIdx, curIdx);
    const accumulateValue = accumulate.reduce((acc, cur) => acc * cur, 1);
    const newVal = value * Math.pow(accumulateValue, curIdx < toIdx ? -1 : 1);
    return { value: newVal, unit: toUnit };
  },
  convertToHigherUnit(value, unit) {
    const { units, baseValue: baseVal } = this.getUnitBaseType(unit);
    const curIdx = units.indexOf(unit);
    let i = curIdx;
    for (i; i < units.length; i++) {
      if (value < baseVal[i]) break;
      value /= baseVal[i];
    }
    i = Math.min(i, units.length - 1);
    return { value, unit: units[i] };
  },
  convertNumberSymbol(value, unit) {
    if (NON_CONVERTIBLE_UNITS.includes(unit)) return { value: value, unit: '' };
    return this.convertToHigherUnit(value, '');
  },
  toSpecificNumberSymbol(value, toUnit, unit) {
    if (NON_CONVERTIBLE_UNITS.includes(unit)) return { value: value };
    return this.convertToSpecificUnit(value, '', toUnit);
  },
  formatNumberInThousands(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  },

  getIconValue(value) {
    if (scpmUtil.isEmpty(value) || value == '-') {
      return `<div style="display:inline-block; max-width: 100%;"> - </div>`;
    }
    const iconClass = scpmUtil.getIconClass(value);
    return `<div style="display:inline-block; max-width: 100%;" class="ellipsis" v-lego-tooltip:ellipsis="'${value}'">
                    <span class="state_icon ${iconClass}"></span>${value}</div>`;
  },
  getIconClass(value) {
    let iconClass = '';
    switch (value) {
      case 'Running':
      case 'RUNNING':
      case 'Started':
      case 'ON':
      case 'On':
      case 'Y':
        iconClass = 'running';
        break;
      case 'Down':
      case 'DOWN':
      case 'OFF':
      case 'N':
        iconClass = 'down';
        break;
      default:
        iconClass = 'default';
        break;
    }
    return iconClass;
  },
  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
  },
  escapeHTML(str) {
    if (!str) return '';
    return _.escape(str);
  },
  capitalizeAllWord(str) {
    if (!str) return '';
    return str
      .split(' ')
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(' ');
  },
  formatObjectNameTooltip(str) {
    if (!str) return '';
    return str.replace(/[<>\\]/g, (match) => {
      const replacements = {
        '\\': '&#92;&#92;',
        '>': '&gt;&#92;',
        '<': '&lt;&#92;'
      };
      return replacements[match];
    });
  },
  formatObjectName(str) {
    if (!str) return '';
    return str.replace(/[<>\\]/g, (match) => {
      const replacements = {
        '\\': '&#92;',
        '>': '&gt;',
        '<': '&lt;'
      };
      return replacements[match];
    });
  },
  deepCopy(obj) {
    //함수등은 copy되지 않으므로 주의)
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch (error) {
      return null;
    }
  },
  convertObjKey(obj, from, to) {
    if (obj[from]) obj[to] = obj[from];
  },
  convertObj(item, target) {
    Object.keys(target).forEach((key) => {
      scpmUtil.convertObjKey(item, key, target[key]);
    });
  },

  convertArr(arr, target) {
    arr.forEach((item) => {
      scpmUtil.convertObj(item, target);
    });
    return arr;
  },
  replaceArr(arr, target) {
    let result = [];
    arr.forEach((item) => {
      let tmp = {};
      Object.keys(target).forEach((key) => {
        tmp[target[key]] = item[key];
      });
      result.push(tmp);
    });
    return result;
  },
  getValueArr(orgArr) {
    var reducer = function (accumulator, item) {
      accumulator.push(item.value);
      return accumulator;
    };
    var result = orgArr.reduce(reducer, []);
    return result;
  },
  isNumber(s) {
    s += ''; // 문자열로 변환
    s = s.replace(/^\s*|\s*$/g, ''); // 좌우 공백 제거
    if (s == '' || isNaN(s)) return false;
    return Number.isInteger(Number(s));
  },
  isUrl(str) {
    var reg_url = /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi;
    return reg_url.test(str);
  },
  isIp(str) {
    var reg_ip =
      /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    return reg_ip.test(str) || str.length === 0;
  },
  isPort(str) {
    if (!scpmUtil.isNumber(str)) {
      return false;
    } else if (Number(str) >= 1 && Number(str) <= 65535) {
      return true;
    }
    return false;
  },
  getByteLength(str) {
    if (str == null) {
      return 0;
    }
    let s = str;
    let b, i, c;
    /* eslint-disable */
    for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);

    return b;
    /* eslint-enable */

    //return str.replace(/[\0-\x7f]|([0-\u07ff]|(.))/g,"$&$1$2").length;
  },
  substringByByte(str, limit) {
    /* eslint-disable */
    let b, i, c;
    for (b = i = 0; (c = str.charCodeAt(i)); ) {
      b += c >> 11 ? 3 : c >> 7 ? 2 : 1;
      if (b > limit) break;
      i++;
    }
    /* eslint-enable */
    return str.substring(0, i);
  },
  isOverByte(str, limit) {
    if (scpmUtil.getByteLength(str) > limit) {
      return true;
    }
    return false;
  },
  validate(targetArr) {
    for (let i in targetArr) {
      let target = targetArr[i];
      //console.log('target.isValid() = ', target);
      if (!target.isValid()) {
        if (typeof target.focus == 'function') target.focus();
        return false;
      }
    }
    return true;
  },

  // clearValidation
  clearValidate(targetArr) {
    for (let i in targetArr) {
      let target = targetArr[i];
      target && target.clearValidation();
    }
  },

  isNotEmpty: function (obj) {
    if (obj == undefined || obj == '') return false;
    else return true;
  },
  isEmpty: function (_str) {
    return !scpmUtil.isNotEmpty(_str);
  },
  secToMin(sec) {
    if (sec == null) return null;
    try {
      let intSec = Number(sec);
      return Math.ceil(intSec / 60);
    } catch (error) {
      return null;
    }
  },
  minToSec(min) {
    if (min == null) return null;
    try {
      let intMin = Number(min);
      return intMin * 60;
    } catch (error) {
      return null;
    }
  },
  toLowerCase(str) {
    if (str == null) return null;
    return str.toLowerCase();
  },
  // 위험도 아이콘
  dangerIcon(type, text) {
    const textValue = this.escapeHTML(text);
    let iconColor = '';
    const levelColor = {
      INFORM: '#868D9C',
      WARN: '#FFCF33',
      FATAL: '#FB6A72',
      GROUP: '#7199ff'
    };
    switch (type) {
      case 'I':
        iconColor = levelColor.INFORM;
        break;
      case 'W':
        iconColor = levelColor.WARN;
        break;
      case 'F':
        iconColor = levelColor.FATAL;
        break;
      case 'G':
        iconColor = levelColor.GROUP;
        break;
      default:
        iconColor = '#fff';
    }

    if (type === 'I' || type === 'W' || type === 'F' || type === 'G') {
      return `<div style="display:inline-block; max-width: 100%; pointer-events: none">
                <div _comment="dangerIcon" class="dangerIcon"
                    style="display: inline-flex; align-items: center; justify-content: center; width:20px; height: 20px; text-align: center; border-radius: 50%;
                        background-color:${iconColor};">
                    <em style="height: 20px; color:#fff; font-style: normal; font-size: 11px; cursor: hand; line-height: 20px;">${textValue}</em>
                </div>
            </div>`;
    } else {
      return '<div style="display:inline-block; max-width: 100%; visibility: hidden">&nbsp;</div>';
    }
  },
  // 에너지바 : 샘플참조 https://jsfiddle.net/L7axhvtz/
  // 성능분석 단위가 '%' 인 metric 데이타의 아이콘+value 표현
  energebarIcon(num) {
    let _barColor = '';
    let _width = '26px';
    let _height = '8px';
    let percent = parseFloat(num).toFixed(2);

    if (90 <= percent) {
      _barColor = '#fb4d58';
    } else if (80 <= percent) {
      _barColor = '#f47d23';
    } else {
      _barColor = '#23d89e';
    }

    return `<div style="display:inline-block; max-width: 100%;">
                    <div _comment="energebarIcon" style="width:${_width};
                            position: relative;
                            display: inline-block;
                            height: 8px;
                            padding: 0;
                            background: #ededeff2;
                            border: 0;
                            border-radius: 4px;
                            overflow: hidden;
                            ">
                        <div style="height:${_height};
                            position: absolute;
                            top: 0;
                            left: 0;
                            background:${_barColor};
                            transition:width 0.5s;" :style="{width:${percent} + '%'}">
                        </div>
                    </div>
                    <div style="display: inline-block;">${percent}</div>
                </div>`;
  },
  // 노바 : 샘플참조 https://jsfiddle.net/L7axhvtz/
  // 성능분석 단위가 '% 외' metric 데이타의 value 표현
  nobarIcon(value, metricUnit, decimal = 0) {
    let tmp;
    let isFileUnit = this.isFileUnit(metricUnit);
    if (isFileUnit) {
      tmp = this.formatFileUnit(value, metricUnit, decimal);
    } else {
      tmp = this.formatNumber(value, decimal);
    }

    let val = tmp.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let unit = tmp.unit;

    return `<div style="display:inline-block; max-width: 100%;">
                    <div style="display: inline-block;">${val} ${unit}</div>
                </div>`;
  },
  // 에너지바 : 샘플참조 https://jsfiddle.net/L7axhvtz/
  energebarIconToTextField(type, percent, backText) {
    let _barColor = '';
    let _width = '';
    let _height = '';
    if (90 <= percent) {
      _barColor = '#FB4D58';
    } else if (80 <= percent) {
      _barColor = '#F47D23';
    } else {
      _barColor = '#23D89E';
    }
    if (type == 'DETAIL1') {
      _width = '100px';
      _height = '8px';
    } else if (type == 'CELL1') {
      _width = '25px';
      _height = '8px';
    }
    return `<div style="display:inline-block; max-width: 100%;">
                    <div _comment="energebarIcon" style="width:${_width};
                            border:0px solid #eeeeee;
                            padding:0px;
                            background:#E6E7EA;
                            border-radius:5px;
                            display: inline-block;">
                        <div style="height:${_height};
                            background:${_barColor};
                            box-shadow:inset 0px -1px 2px rgba(0,0,0,0.4);
                            border-radius:4px;
                            transition:width 0.5s;width:${percent}px;"">
                        </div>
                    </div>
                    <div style="display: inline-block;">${percent}${backText || ''}</div>
                </div>`;
  },
  // 구동 아이콘
  runningIcon(type, text) {
    const iconColor = PRODUCTS_STATE_COLORS[type] ?? '#EAEAEA';
    const textValue = this.escapeHTML(text);
    return `<div class="ellipsis" style="align-items: center; display: grid; grid-template-columns: auto 1fr;" v-lego-tooltip:ellipsis="'${textValue}'">
              <div style="grid-column: 1">
                <div _comment="runningIcon" style="border-radius: 50%;
                    min-width: 12px;
                    height: 12px;
                    margin-right: 6px;
                    background: ${iconColor};
                    color: black;
                    text-align: center;
                    display: inline-block;"></div>
              </div>
              <span class="ellipsis" style="grid-column: 2; text-align: left;">${textValue}</span>  
            </div>`;
  },
  // 업데이트 아이콘
  latestIcon(isLastYn, text) {
    let iconColor = '#EAEAEA';
    if (isLastYn == 'Y') {
      iconColor = '#1DDB16';
    }
    return `<div class="ellipsis" style="display: flex; max-width: 100%; align-items: center;" v-lego-tooltip:ellipsis="'${text}'">
                    <div _comment="runningIcon" style="border-radius: 50%;
                        width: 12px;
                        height: 12px;
                        background: ${iconColor};
                        color: black;
                        text-align: center;
                        display: inline-block;">
                    </div>&nbsp;${text}
                </div>`;
  },
  // 로그 에이전트 상태 아이콘
  agentStateIcon(value) {
    let iconCss = '';
    if (value == 'Started') {
      iconCss = 'started';
    } else if (value == 'Stopped') {
      iconCss = 'stopped';
    } else {
      return `<div class="ellipsis" v-lego-tooltip:ellipsis="'${value}'">${value}</div>`;
    }
    return `<div class="ellipsis" style="display:inline-block; max-width: 100%;" v-lego-tooltip:ellipsis="'${value}'">
                    <i class="ui-icon i-${iconCss}"></i>${value}
                </div>`;
  },
  // getTomorrowMidnight() {
  //     let today = new Date();
  //     let tomorrow = new Date(today.setDate(today.getDate() + 1));
  //     var timezoneOffset = new Date().getTimezoneOffset() * 60000;
  //     tomorrow.setHours(0);
  //     tomorrow.setMinutes(0);
  //     tomorrow.setSeconds(0);
  //     tomorrow.setMilliseconds(0);
  //     var timezoneTomorrow = new Date(tomorrow - timezoneOffset);
  //     return timezoneTomorrow;
  //     //console.log('tomorrow = ', timezoneDate.toISOString());
  // },
  getMidnight(day) {
    let today = new Date();
    let d_day = new Date(today.setDate(today.getDate() + day));
    var timezoneOffset = new Date().getTimezoneOffset() * 60000;
    d_day.setHours(0);
    d_day.setMinutes(0);
    d_day.setSeconds(0);
    d_day.setMilliseconds(0);
    var timezoneDay = new Date(d_day - timezoneOffset);
    //console.log('timezoneDay = ', timezoneDay.toISOString());
    return timezoneDay;
    //console.log('tomorrow = ', timezoneDate.toISOString());
  },
  getNowTimezone() {
    var timezoneOffset = new Date().getTimezoneOffset() * 60000;
    var timezoneDate = new Date(Date.now() - timezoneOffset);
    return timezoneDate;
  },
  isoStrToDateStr(str) {
    return scpmUtil.formatDate(new Date(str));
  },
  addOneMinute(time) {
    return moment(time).add(1, 'minutes').startOf('minute').toISOString();
  },
  formatDate(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
    // var year = date.getFullYear().toString();

    // var month = date.getMonth() + 1;
    // month = month < 10 ? '0' + month.toString() : month.toString();

    // var day = date.getDate();
    // day = day < 10 ? '0' + day.toString() : day.toString();

    // var hour = date.getHours();
    // hour = hour < 10 ? '0' + hour.toString() : hour.toString();

    // var minites = date.getMinutes();
    // minites = minites < 10 ? '0' + minites.toString() : minites.toString();

    // var seconds = date.getSeconds();
    // seconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();

    // return `${year}-${month}-${day} ${hour}:${minites}:${seconds}`;
  },

  /**
   * 단위타입 구하기
   * @param {String} unit 단위
   * @returns 단위타입 (FILE, TIME, NUM)
   */
  getUnitType(unit) {
    let result = 'NUM';
    let unitTypes = {
      FILE: ['BYTES', 'KB', 'MB', 'GB', 'TB', 'PB'],
      TIME: ['USEC', 'MS', 'SEC', 'MIN', 'HOUR', 'DAY']
    };
    Object.keys(unitTypes).forEach((type) => {
      if (unitTypes[type].indexOf(unit.toUpperCase()) > -1) {
        result = type;
      }
    });
    return result;
  },

  /**
   * 파일 단위 인지 여부 반환
   * @param {String} unit 단위
   * @returns true & false;
   */
  isFileUnit(unit) {
    let sizes = ['BYTES', 'KB', 'MB', 'GB', 'TB', 'PB'];
    return sizes.indexOf(unit.toUpperCase()) > -1;
  },

  /**
   * 단위 구하기 (max 값으로)
   * @param {string} metricUnit   단위
   * @param {Array} datas             metric datas
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  getMetricUnit(metricUnit, datas) {
    let allValues = [];
    datas.forEach((item) => {
      let perData = item.perfData || item.data;

      allValues.push(
        Math.max(
          ...perData.map((m) => {
            let value;
            if (m.value) {
              value = Number(m.value);
            } else {
              value = Number(m[1]);
            }
            return value * Math.sign(value);
          })
        )
      );
    });
    let _maxValue = Math.max(...allValues);

    let tmp;
    let unitType = this.getUnitType(metricUnit);

    if (unitType == 'FILE') {
      tmp = this.formatFileUnit(_maxValue, metricUnit, 2);
    } else if (unitType == 'TIME') {
      tmp = this.formatTimes(_maxValue, metricUnit, 2);
    } else {
      tmp = this.formatNumber(_maxValue, 2);
    }
    let unit = tmp.unit || metricUnit;
    return {
      orgUnit: unitType == 'NUM' ? metricUnit : unit,
      unit: unit
    };
  },

  /**
   * 단위 구하기 (max 값으로)
   * @param {string} metricUnit   단위
   * @param {Array} datas             metric datas
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  getMetricFixedUnit(metricUnit, datas) {
    let allValues = [];
    let fixedUnit = datas[0].fixedUnit;
    let isFixeUnitMetric = fixedUnit != null;

    datas.forEach((item) => {
      allValues.push(
        Math.max(
          ...item.perfData.map((m) => {
            let value = Number(m.value);
            return value * Math.sign(value);
          })
        )
      );
    });
    let _maxValue = Math.max(...allValues);

    let tmp;
    let unitType = this.getUnitType(metricUnit);

    if (unitType == 'FILE') {
      tmp = this.formatFileUnit(_maxValue, metricUnit, 2);
    } else if (unitType == 'TIME') {
      tmp = this.formatTimes(_maxValue, metricUnit, 2);
    } else {
      tmp = this.formatNumber(_maxValue, 2);
    }
    let unit = tmp.unit || metricUnit;

    if (isFixeUnitMetric) {
      unit = fixedUnit;
      metricUnit = fixedUnit;
    }

    return {
      orgUnit: unitType == 'NUM' ? metricUnit : unit,
      unit: unit
    };
  },

  /** 단위 정보
   * @param {Array} datas             metric datas
   * @returns
   *
   */
  getUnitInfo(datas) {
    // 단위 구하기 (bytes)
    let unit = datas[0].metricUnit;
    let unitType = this.getUnitType(unit);
    let metricUnit = this.getMetricUnit(unit, datas);

    let callFnc = '';
    let args = [];
    if (unitType == 'FILE') {
      callFnc = 'formatFileUnit';
      args = [unit, 2, metricUnit.unit];
    } else if (unitType == 'TIME') {
      callFnc = 'formatTimes';
      args = [unit, 2, metricUnit.unit];
    } else {
      callFnc = 'formatNumber';
      args = [2, metricUnit.unit];
    }

    return {
      metricUnit: metricUnit, // unit
      callFnc: callFnc, // 단위환산 호출 함수
      args: args // 단위환산 호출 함수 arguments
    };
  },

  /** 단위 정보 (fixed)
   * @param {Array} datas             metric datas
   * @returns
   *
   */
  getFixedUnitInfo(datas) {
    // 단위 구하기 (bytes)
    // console.log('datas    : ' + JSON.stringify(datas));

    let unit = datas[0].metricUnit;
    let unitType = this.getUnitType(unit);
    let metricUnit = this.getMetricUnit(unit, datas);
    let fixedUnit = datas[0].fixedUnit;
    let isFixeUnitMetric = fixedUnit != null;

    if (isFixeUnitMetric) {
      metricUnit = {
        orgUnit: fixedUnit,
        unit: fixedUnit
      };
    }

    let callFnc = '';
    let args = [];
    if (unitType == 'FILE') {
      callFnc = 'formatFileUnit';
      args = [unit, 2, metricUnit.unit];
    } else if (unitType == 'TIME') {
      if (isFixeUnitMetric) {
        callFnc = 'formatTimesForFixedUnit';
        args = [unit, 2, fixedUnit, isFixeUnitMetric];
      } else {
        callFnc = 'formatTimes';
        args = [unit, 2, metricUnit.unit];
      }
    } else {
      callFnc = 'formatNumber';
      args = [2, metricUnit.unit];
    }

    return {
      metricUnit: metricUnit, // unit
      callFnc: callFnc, // 단위환산 호출 함수
      args: args // 단위환산 호출 함수 arguments
    };
  },

  formatFileSizeUnit(number) {
    if (!+number) return 'bytes';
    const k = 1024;
    const i = Math.floor(Math.log(number) / Math.log(k));
    const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    return sizes[i] || 'bytes';
  },

  getMaxUnit(unitType, data) {
    let maxUnit = '';
    let valueOfChart = [];

    if (data.contents) {
      data.contents.forEach((item) => {
        valueOfChart.push(...item.perfData);
      });
    } else {
      data.forEach((item) => {
        valueOfChart.push(...item.perfData);
      });
    }

    if (unitType === 'FILE') {
      const maxValue = Math.max(...valueOfChart.map((element) => +element.value));
      maxUnit = this.formatFileSizeUnit(maxValue);
    }
    return maxUnit;
  },

  /**
   * bytes 단위 환산
   * @param {number} value value,
   * @param {string} unit  단위
   * @param {number} decimals 반올림할 소숫점 자리수,
   * @param {string} fixedUnit  fixed 단위
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  formatFileUnit(value, unit, decimals, fixedUnit = '', isCharStatusOrInstance = false) {
    if (value == null) {
      return {
        value: value,
        unit: ''
      };
    }

    value = Number(value);
    if (value === 0 && !fixedUnit) {
      return {
        value: value,
        unit: unit
      };
    }

    let m = Math.sign(value);
    value = value * m;
    const valArg = value;

    unit = unit == 'bytes' ? unit : unit.toUpperCase();
    let KB = 1024;
    let sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    value = value * Math.pow(KB, sizes.indexOf(unit));
    const idxUnitdefault = sizes.indexOf(unit);
    let i;

    if (fixedUnit) {
      i = sizes.indexOf(fixedUnit);
    } else {
      i = value != 0 ? Math.floor(Math.log(value) / Math.log(KB)) : value;
    }

    if (i == -1 || isNaN(i)) {
      return {
        value: value.toFixed(decimals) * m,
        unit: sizes[0]
      };
    } else {
      if (!fixedUnit && !isCharStatusOrInstance) {
        let v = value / Math.pow(KB, i);
        if (i > 0 && v < 10) {
          i = i - 1;
        }
      }

      if (valArg < KB && idxUnitdefault > i) {
        return {
          value: Number(valArg).toFixed(decimals) * m,
          unit: sizes[idxUnitdefault]
        };
      }
      return {
        value: parseFloat((value / Math.pow(KB, i)).toFixed(decimals)) * m,
        unit: sizes[i]
      };
    }
  },

  /**
   * bytes 단위 환산
   * @param {number} bytes bytes value,
   * @param {number} decimals 반올림할 소숫점 자리수,
   * @param {string} unit  fixed 단위
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  formatBytes(bytes, decimals, unit) {
    if (bytes == null) {
      return {
        value: bytes,
        unit: ''
      };
    }
    bytes = Number(bytes);
    let KB = 1024;
    let sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    let i;
    if (unit) {
      i = sizes.indexOf(unit);
    } else {
      i = bytes != 0 ? Math.floor(Math.log(bytes) / Math.log(KB)) : bytes;
    }

    if (i == -1 || isNaN(i)) {
      return {
        value: bytes.toFixed(decimals),
        unit: sizes[0]
      };
    } else {
      if (!unit) {
        let v = bytes / Math.pow(KB, i);
        if (i > 0 && v < 10) i = i - 1;
      }
      return {
        value: parseFloat((bytes / Math.pow(KB, i)).toFixed(decimals)),
        unit: sizes[i]
      };
    }
  },

  /**
   * 숫자 단위 환산
   * @param {number} num number value,
   * @param {number} decimals 반올림할 소숫점 자리수,
   * @param {string} unit  fixed 단위
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  formatNumber(num, decimals, unit) {
    if (num == null) {
      return {
        value: num,
        unit: ''
      };
    }
    num = Number(num);
    let m = Math.sign(num);
    num = num * m;

    let n = 1000;
    let units = ['', 'K', 'M', 'G', 'T', 'P'];
    let i;
    if (unit) {
      i = units.indexOf(unit);
    } else {
      i = num != 0 ? Math.floor(Math.log(num) / Math.log(n)) : num;
    }

    if (i == -1 || isNaN(i)) {
      return {
        value: num.toFixed(decimals) * m,
        unit: units[0]
      };
    } else {
      if (!unit) {
        let v = num / Math.pow(n, i);
        if (i > 0 && v < 10) i = i - 1;
      }
      return {
        value: parseFloat((num / Math.pow(n, i)).toFixed(decimals)) * m,
        unit: units[i]
      };
    }
  },

  /**
   * 시간 단위 환산
   * @param {number} value 시간 value,
   * @param {string} unit  시간 단위
   * @param {number} decimals 반올림할 소숫점 자리수,
   * @param {string} fixedUnit  fixed 단위
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  formatTimes(value, unit, decimals, fixedUnit) {
    if (value === null) {
      return {
        value: value,
        unit: ''
      };
    }
    value = Number(value);

    if (value === 0 && !fixedUnit) {
      return {
        value: value,
        unit: unit
      };
    }

    let types = ['usec', 'ms', 'sec', 'min', 'hour', 'day'];
    let calc = [1000, 1000, 60, 60, 24, 1];

    let i = types.indexOf(unit);
    if (i == 0 && !fixedUnit && value < 1000) {
      return {
        value: value.toFixed(decimals),
        unit: types[0]
      };
    }

    let microseconds = calc.reduce((acc, cur, idx) => {
      if (idx < i) acc = acc * cur;
      return acc;
    }, value);

    if (fixedUnit) {
      let k = types.indexOf(fixedUnit);

      let v = calc.reduce((acc, cur, idx) => {
        if (idx < k) acc = acc / cur;
        return acc;
      }, microseconds);

      return {
        value: v.toFixed(decimals),
        unit: fixedUnit
      };
    }

    let result = null;
    for (let i = 0; i < types.length; i++) {
      let v = calc.reduce((acc, cur, idx) => {
        if (idx < i) acc = acc / cur;
        return acc;
      }, microseconds);
      if (i < 5 && v < calc[i]) {
        result = {
          value: v.toFixed(decimals),
          unit: types[i]
        };
        break;
      }
      if (i == 5) {
        result = {
          value: v.toFixed(decimals),
          unit: types[i]
        };
      }
    }

    return result;
  },

  /**
   * 시간 단위 환산
   * @param {number} value 시간 value,
   * @param {string} unit  시간 단위
   * @param {number} decimals 반올림할 소숫점 자리수,
   * @param {string} fixedUnit  fixed 단위
   * @param {boolean} isFixedUnitMetric  고정 단위를 적용하는 메트릭 여부
   * @returns 계산된 value와 단위(unit)를 Object로 반환
   */
  formatTimesForFixedUnit(value, unit, decimals, fixedUnit, isFixeUnitMetric) {
    if (value === null) {
      return {
        value: value,
        unit: ''
      };
    }
    value = Number(value);

    if (value === 0 && !fixedUnit) {
      return {
        value: value,
        unit: unit
      };
    }

    let types = ['usec', 'ms', 'sec', 'min', 'hour', 'day'];
    let calc = [1000, 1000, 60, 60, 24, 1];

    let i = types.indexOf(unit);
    if (i == 0 && !fixedUnit && value < 1000) {
      return {
        value: value.toFixed(decimals),
        unit: types[0]
      };
    }

    let microseconds = calc.reduce((acc, cur, idx) => {
      if (idx < i) acc = acc * cur;
      return acc;
    }, value);

    if (fixedUnit) {
      let k = types.indexOf(fixedUnit);
      let v = calc.reduce((acc, cur, idx) => {
        if (idx < k) acc = acc / cur;
        return acc;
      }, microseconds);

      return {
        value: isFixeUnitMetric ? Math.trunc(v) : v.toFixed(decimals),
        unit: fixedUnit
      };
    }

    let result = null;
    for (let i = 0; i < types.length; i++) {
      let v = calc.reduce((acc, cur, idx) => {
        if (idx < i) acc = acc / cur;
        return acc;
      }, microseconds);
      if (i < 5 && v < calc[i]) {
        result = {
          value: v.toFixed(decimals),
          unit: types[i]
        };
        break;
      }
      if (i == 5) {
        result = {
          value: v.toFixed(decimals),
          unit: types[i]
        };
      }
    }

    return result;
  },

  fittingString(str, maxWidth) {
    let c = document.getElementById('canvas').getContext('2d');
    c.font = '14px "Noto Sans KR"';
    var width = c.measureText(str).width;
    var ellipsis = '…';
    var ellipsisWidth = c.measureText(ellipsis).width;
    if (width <= maxWidth || width <= ellipsisWidth) {
      return str;
    } else {
      var len = str.length;
      while (width >= maxWidth - ellipsisWidth && len-- > 0) {
        str = str.substring(0, len);
        width = c.measureText(str).width;
      }
      return str + ellipsis;
    }
  },

  paramsEncoding: (params) => {
    let result = '';
    Object.keys(params).forEach((key) => {
      result += `${key}=${encodeURIComponent(params[key])}&`;
    });
    return result.substring(0, result.length - 1);
  },
  getK8sObjectLists() {
    return [
      { text: 'Cluster', value: 'cluster' },
      { text: 'Namespace', value: 'namespace' },
      { text: 'Node', value: 'node' },
      { text: 'Replica Set', value: 'replicaset' },
      { text: 'Deployment', value: 'deployment' },
      { text: 'Stateful Set', value: 'statefulset' },
      { text: 'Daemon Set', value: 'daemonset' },
      { text: 'Job', value: 'job' },
      { text: 'CronJob', value: 'cronjob' },
      { text: 'Pod', value: 'pod' }
    ];
  },
  getK8sWorkloadList() {
    return ['deployment', 'statefulset', 'daemonset', 'cronjob', 'job', 'replicaset'];
  },
  getLstSubResourceType() {
    return ['Kubernetes', 'Load Balancer', 'DataOps', 'DataFlow', 'QuickQuery', 'DataWrangler'];
  },
  replaceMonTargetText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.PRODUCT_NAME, '');
  },
  replaceEventTemplateNameText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.EVENT_TEMPLATE_NAME, '');
  },
  replaceEventTemplateNameTextAndWhitespace(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.EVENT_TEMPLATE_NAME, '');
  },
  replaceLbNameText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.LB_NAME, '');
  },
  replaceLbServiceNameText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.LB_SERVICE_NAME, '');
  },
  replaceEventAlarmText(text, sel, self = this) {
    if (sel == 'email') {
      return text.replace(self.$const.NOT_ALLOWED_REGEX.EVENT_ALARM, '');
    } else {
      return text.replace(self.$const.NOT_ALLOWED_REGEX.EVENT_ALARM_COMM, '');
    }
  },
  replaceEventAlarmSearch(text, sel, self = this) {
    return text.replace(self.$const.NOT_ALLOWED_REGEX.EVENT_ALARM_SEARCH, '');
  },
  replaceDBVersionText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.DB_VERSION, '');
  },
  replaceConnectedVPCText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.CONNECTED_VPC, '');
  },
  replaceServiceDomainText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.SERVICE_DOMAIN, '');
  },
  replaceClusterNameText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.CLUSTER_NAME, '');
  },
  replaceGpuClusterNameText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.GPU_CLUSTER_NAME, '');
  },
  replaceGpuClusterNameTextAndeWhitespace(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.GPU_CLUSTER_NAME, '');
  },
  replaceFilterText(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.FILTER, '');
  },
  replaceFilterTextAndeWhitespace(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.FILTER, '');
  },
  replaceFilterTextNetwork(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.FILTER_FOR_NETWORKING, '');
  },
  replaceMonTargetTextAndWhitespace(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.PRODUCT_NAME, '');
  },
  replaceIpAddress(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.IP_ADDRESS, '');
  },
  replaceToOnlyNumber(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.ONLY_NUMBER, '');
  },
  replaceToOnlyNumberDot(text) {
    let newText = text.replace(/^\./g, '');
    const firstIndex = newText.indexOf('.');

    if (firstIndex >= 0) {
      newText =
        newText.substring(0, firstIndex + 1) + newText.substring(firstIndex + 1).replace(/\./g, '');
    }

    return newText.replace(this.$const.NOT_ALLOWED_REGEX.ONLY_NUMBER_DOT, '').replace(/^\./g, '');
  },
  replaceWhitespace(text) {
    return text
      .replace(this.$const.NOT_ALLOWED_REGEX.WHITESPACE_START, '')
      .replace(this.$const.NOT_ALLOWED_REGEX.WHITESPACE, ' ');
  },
  replaceEventMessage(text) {
    return text.replace(this.$const.NOT_ALLOWED_REGEX.EVENT_FILTER_NAME, '');
  },
  requireInputCommon(text) {
    return /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.]/g.test(text);
  },
  requireInputMetricName(text) {
    return /[^A-Za-z._]/g.test(text);
  },
  authErrorMessage(errorData, userEmail) {
    const getServiceValues = (data, key) => {
      const values = data.filter(({ name }) => name === key).map((el) => el.value);
      const uniqueValues = Array.from(new Set(values.flat()));
      return uniqueValues.join(', ');
    };
    const serviceName = getServiceValues(errorData, 'service');
    const serviceAction = getServiceValues(errorData, 'action');
    const resourceId = getServiceValues(errorData, 'resourceId');
    const resouceHtml = resourceId
      ? `
      <div style="display: flex; gap: 8px; margin-top: 10px;">
        <div style="width: 80px;">[Resource]:</div>
        <div style="flex: 1;">
          ${resourceId}
        </div>
      </div>
    `
      : '';
    return `
        <div class="auth-error-content" style="margin: 0 -20px;">
          <div>${userEmail}</div>
          <div>${$t('errorCode.authorizationCheck.contact')}</div>
          <p style="color: #2f3237; font-size: 14px; font-weight: 500">
            ${$t('errorCode.authorizationCheck.required_list')}
          </p>
          <div style="padding: 12px; background: #f7f7f8;">
            <div style="display: flex; gap: 8px;">
              <div style="width: 80px;">[Service]:</div>
              <div style="flex: 1;">
                ${scpmUtil.capitalize(serviceName)}
              </div>
            </div>
            <div style="display: flex; gap: 8px; margin-top: 10px;">
              <div style="width: 80px;">[Action]:</div>
              <div style="flex: 1;">
                ${scpmUtil.capitalize(serviceAction)}
              </div>
            </div>
            ${resouceHtml}
          </div>
        </div>
    `;
  },
  alertModal(message = '', title, fn) {
    if (message == '') return;
    if (typeof title == 'undefined') {
      title = this.$t('title.notice');
    }
    if (typeof title == 'function' || typeof title == 'object') {
      fn = title;
      title = this.$t('title.notice');
    }
    // 권한 관련 메시지 일경우
    if (typeof message == 'object') {
      if (message.code == 'AccessDenied') {
        title = this.$t('errorCode.authorizationCheck.deny_title');
        const userEmail = window.sessionStorage.getItem('userEmail') || 'gilding.hong@samsung.com';
        const tranUserEmail = this.$t('errorCode.authorizationCheck.deny', [userEmail]);
        message = this.$util.authErrorMessage(message.params, tranUserEmail);
      } else {
        title = this.$t('title.notice');
        message = this.$t(`errorCode.${message.code}`) || message.message;
      }
    }

    let act = {
      type: 'alert',
      title: title,
      message: message,
      action: () => {
        this.$el.scrollIntoView(); //
      }
    };
    if (typeof fn == 'object') {
      if (typeof fn.action == 'function') {
        act['action'] = fn.action;
      }
      if (typeof fn.cancel == 'function') {
        act['cancel'] = fn.cancel;
        act['type'] = 'confirm';
        // act['title'] = this.t('page.eventStatus.confirm')
      }
    } else if (typeof fn == 'function') {
      act = { ...act, action: fn };
    }

    this.$modal.open(act);
  },
  getBigNumber(num) {
    let big = Big(num);
    if (Number.isInteger(num)) {
      return String(num);
    } else {
      if (big.e < -1) {
        return `${big.s < 0 ? '-' : ''}${num.toFixed(Math.abs(big.e))}${big.c
          .join('')
          .substring(1)}`;
      } else {
        return String(num);
      }
    }
  },
  comparedOprator(value) {
    const resultTxt = {
      EQ: '=',
      NE: '!=',
      GE: '<=',
      GT: '<',
      LE: '>=',
      LT: '>'
    };
    return Object.keys(resultTxt).includes(value) ? resultTxt[value] : '';
  },
  minComparedOprator(value) {
    return this.comparedOprator(value);
  },
  maxComparedOprator(value) {
    const resultTxt = {
      EQ: '=',
      NE: '!=',
      GE: '>=',
      GT: '>',
      LE: '<=',
      LT: '<'
    };
    return Object.keys(resultTxt).includes(value) ? resultTxt[value] : '';
  },

  // Rhel CoreOS  === os info 여부
  isRhelCoreOs(value) {
    if (value) {
      return value.toLowerCase().includes('coreos');
    }
    return false;
  },

  // LB L7 check
  isLayerSeven(value) {
    if (value) {
      return value.toLowerCase().includes('l7');
    }
    return false;
  },

  // LB Packet Metric check
  isPacketMetric(value) {
    if (value) {
      return value.toLowerCase().includes('packet');
    }
    return false;
  },
  /**
   *
   * @param {array} point is mouse position
   * @param {array} size the size of dom echarts container. For example: {contentSize: [width, height], viewSize: [width, height]}.
   */
  getPositionTooltip(point, size) {
    // fixed position
    const MR = 2;
    let left = point[0] + MR;
    let top = point[1] + MR;

    if (left + size.contentSize[0] > size.viewSize[0]) {
      left = left - size.contentSize[0] - MR * 2;
    }
    if (top + size.contentSize[1] > size.viewSize[1]) {
      top = top - size.contentSize[1] - MR * 2;
    }
    return [left, top];
  },
  getDateFormat(value, type) {
    if (type === '5m') {
      return moment(Number(value)).format('HH:mm');
    } else {
      let time = moment(Number(value)).format('MM-DD HH').split('');
      time[5] = '\n';
      return time.join('') + 'h';
    }
  },
  refactorIPAddress(ip) {
    let ipv = ip.slice(0, 3);
    if (Number(ipv) > 255) return ip.slice(1, 4);
    return ipv;
  },
  formatMaxValue(unitType, value, unit, _unit, isFixeUnitMetric = false) {
    if (unitType == 'FILE') {
      return this.formatFileUnit(value, unit, 2, _unit).value;
    } else if (unitType == 'TIME') {
      return this.formatTimesForFixedUnit(value, unit, 2, _unit, isFixeUnitMetric).value;
    } else {
      return this.formatNumber(value, 2, _unit).value;
    }
  },
  sortFunc(a, b) {
    const strA = String(a);
    const strB = String(b);
    if (typeof a === 'number' && typeof b !== 'number') {
      return -1;
    } else if (typeof a !== 'number' && typeof b === 'number') {
      return 1;
    }
    if (strA < strB) {
      return -1;
    } else if (strA > strB) {
      return 1;
    }
    return 0;
  },

  customSort(items, sortKey, sortDirection, sortPriority = true) {
    return items.sort((x, y) => {
      const compare1 = x[sortKey] || '';
      const compare2 = y[sortKey] || '';
      return this.compareOperator(compare1, compare2, sortDirection, sortPriority);
    });
  },
  compareOperator(x, y, sortDirection, sortPriority) {
    const priority = {
      number: 1,
      character: 2,
      korean: 3,
      special: 4,
      unknown: 5
    };

    const getPriority = (char) => {
      if (/[0-9]/.test(char)) return priority['number'];
      if (/[a-zA-Z]$/.test(char)) return priority['character'];
      if (/[^a-zA-Z0-9\uac00-\ud7af]/.test(char)) return priority['special'];
      if (/[\uac00-\ud7af]/.test(char)) return priority['korean'];
      return priority['unknown'];
    };
    const a = x.trim();
    const b = y.trim();
    const minLength = Math.min(a.length, b.length);
    const sortAsc = sortDirection === SORT_DIRECTION.ASC;

    for (let i = 0; i < minLength; i++) {
      const priorityA = getPriority(a[i]);
      const priorityB = getPriority(b[i]);

      if (sortPriority && priorityA !== priorityB) return sortAsc ? priorityA - priorityB : priorityB - priorityA;
      if (priorityA == 2) {
        const lowerA = a[i].toLowerCase();
        const lowerB = b[i].toLowerCase();

        if (lowerA !== lowerB)
          return sortAsc ? lowerA.localeCompare(lowerB) : lowerB.localeCompare(lowerA);
      }

      if (a[i] !== b[i]) return sortAsc ? a[i].localeCompare(b[i]) : b[i].localeCompare(a[i]);
    }
    return sortAsc ? a.length - b.length : b.length - a.length;
  },
  customSortCaseIndepent(array = [], field, order = 'asc') {
    const sortOrder = {
      special: 1,
      number: 2,
      alpha: 3,
      korean: 4
    };
    const getCategory = (char) => {
      if (/^[^a-zA-Z0-9\uAC00-\uD7AF]$/.test(char)) return sortOrder['special'];
      if (/^\d$/.test(char)) return sortOrder['number'];
      if (/^[a-zA-Z]$/.test(char)) return sortOrder['alpha'];
      if (/^[\uAC00-\uD7AF]$/.test(char)) return sortOrder['korean'];
      return 5;
    };

    const sortedArray = _.orderBy(
      array,
      [
        (item) => {
          return item[field]
            .split('')
            .map((char) => [getCategory(char.toLowerCase()), char.toLowerCase()]);
        }
      ],
      [order]
    );
    return sortedArray;
  },
  getPeriodUnit(unit) {
    return PERIOD_UNITS[unit];
  },
  getDurationSecond(value) {
    let seconds = Number(value);
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    let s = Math.floor(seconds % 60);

    let dDisplay = d > 0 ? d + ' ' + $t('label.day') : '';
    let hDisplay = h > 0 ? h + ' ' + $t('label.hour') : '';
    let mDisplay = m > 0 ? m + ' ' + $t('label.minute') : '';
    let sDisplay = s > 0 ? s + ' ' + $t('label.seconds') : '';
    return `${dDisplay + ' ' + hDisplay + ' ' + mDisplay + ' ' + sDisplay}`;
  },
  formatDateSearchQuery(fromDate = '', toDate = '') {
    let frmDate = '',
      tDate = '';
    if (fromDate) {
      frmDate = moment(`${fromDate} 00:00:00.000`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString();
    }
    if (toDate) {
      tDate = moment(`${toDate} 23:59:59.999`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString();
    }
    return { fromDate: frmDate, toDate: tDate };
  },
  getEventLevel(eventLevelSet) {
    let result = '<div style="text-align: center;line-height:28px">';
    EVENT_LEVELS.forEach((item) => {
      const key = Array.from(item)[0];
      if (eventLevelSet.includes(item))
        result += `<div class="ellipsis" v-lego-tooltip="'${this.capitalize(
          item
        )}'">${this.dangerIcon(key, key)} </div>`;
    });
    result += '</div>';
    return result;
  },
  getListTag(data) {
    let chipItemDv = [];
    const listTag = get(data, 'contents', []);
    if (listTag.length) {
      for (let i = 0; i < listTag.length; i++) {
        const tagData = this.getTagText(listTag[i]);
        chipItemDv.push({ value: tagData, medium: true, colorType: 'normal' });
      }
    }
    return this.customSort(chipItemDv, 'value');
  },

  getTagText(item) {
    if (!item.tagValue?.trim()) {
      return item.tagKey;
    }

    return item.tagKey + ';' + item.tagValue;
  },

  getAccountId() {
    return window.sessionStorage.getItem('accountId') ?? '';
  },
  // 변환  +09:00 => GMT+9, +09:30 => GMT+9:30, 00:00 => 0
  gmtFormat(v) {
    const gmt = this.gmtOffset(v);
    return gmt.replace(/\s*([+-])0?(\d+):?(\d+)?/, (_, sign, hours, minutes) => {
      return `${sign}${parseInt(hours)}${parseInt(minutes) ? `:${minutes}` : ''}`;
    });
  },

  gmtOffset(v) {
    return moment().utcOffset(v).format('[GMT] Z');
  },

  gmtName(v) {
    return moment.tz
      .names()
      .filter((tz) => this.gmtFormat(moment.tz(tz).utcOffset()) === v)
      .join(', ');
  },

  getTextTimeZone(v) {
    if (!v) return;
    const txt = this.getListTimeZone().find((tz) => v === tz.value)?.text;
    return txt && `${txt},`;
  },

  getListTimeZone() {
    const tmp = moment.tz
      .names()
      .map((tz) => moment.tz(tz).utcOffset())
      .sort((a, b) => a - b);

    return [...new Set(tmp)].map((e) => ({
      value: this.gmtFormat(e),
      text: this.gmtOffset(e)
    }));
  },

  getTimeZoneUser() {
    const tzUser = window.sessionStorage.getItem('timeZoneInfo') || tzDefault;
    return this.gmtFormat(moment.tz(tzUser).format('Z'));
  },

  getDefaultTz(mode = '', action = '') {
    if (mode === 'modify' || action === ACTION_EVENT.FIND_TEMPLATE)
      return this.gmtFormat(tzDefault);
    else if (mode === 'add') return this.getTimeZoneUser();
    return null;
  },
  getColorOfChart(numberLine) {
    let lstColor = [];
    for (let i = 0; i < numberLine; i++) {
      let r, g, b;
      do {
        r = Math.floor(Math.random() * 256);
        g = Math.floor(Math.random() * 256);
        b = Math.floor(Math.random() * 256);
      } while (r === g && g === b);
      const color =
        '#' +
        r.toString(16).padStart(2, '0') +
        g.toString(16).padStart(2, '0') +
        b.toString(16).padStart(2, '0');
      lstColor.push(color);
    }
    return lstColor;
  },
  updateDbVersionText(resourceType, schema = [], tableHeaderCustomize) {
    const tranKey = resourceType === 'search-engine' ? 'version' : 'dbVersion';
    const tranText = $t(`searchLabel.${tranKey}`);

    schema.fields.forEach((item) => {
      if (item.id === 'dbVersion') item.label = tranText;
    });
    tableHeaderCustomize.dbVersion.text = tranKey;
  },
  getSearchModel(searchModel) {
    Object.keys(searchModel).forEach((key) => {
      if (key !== 'productTypeCode') {
        if (Array.isArray(searchModel[key])) {
          searchModel[key] = [];
        } else searchModel[key] = '';
      }
    });
    return { searchModel };
  },

  validatorInputMetric(value, firstDotIndex) {
    const val = value
      .replace(constant.NOT_ALLOWED_REGEX.NOT_ALLOWED_SPACE, '')
      .replace(constant.NOT_ALLOWED_REGEX.CONSECUTIVE_DOT, '.')
      .replace(constant.NOT_ALLOWED_REGEX.FIRST_DOT, '');

    const beforeDotIndex = val.indexOf('.');

    if (beforeDotIndex >= firstDotIndex) {
      const data = val.processTwoDot();
      return {
        val: data,
        beforeDotIndex: data.indexOf('.')
      };
    }

    const reverseData = val.reverseString().processTwoDot().reverseString();

    return {
      val: reverseData,
      beforeDotIndex: reverseData.indexOf('.')
    };
  },

  getLocateString(locale) {
    if (!locale) locale = constant.DEFAULT_LANGUAGE;

    const localeString = constant.LANGUAGES[locale];

    if (!localeString) return constant.LANGUAGES[constant.DEFAULT_LANGUAGE];

    return constant.LANGUAGES[locale];
  }
};
String.prototype.replaceAll = function (searchStr, replacement) {
  return this.split(searchStr).join(replacement);
};

String.prototype.reverseString = function () {
  return this.split('').reverse().join('');
};

String.prototype.processTwoDot = function () {
  return processTwoDot(this);
};

const processTwoDot = (string) => {
  const regex = constant.NOT_ALLOWED_REGEX.NOT_ALLOWED_TWO_DOT;

  return string.replace(regex, (_, p1, p2) => {
    if (p2) {
      return p1 + p2.replace(constant.NOT_ALLOWED_REGEX.NOT_ALLOWED_DOT, '');
    }
    return string;
  });
};

export default {
  install(Vue) {
    Vue.config.globalProperties.$util = scpmUtil;
    Vue.config.globalProperties.$alert = scpmUtil.alertModal;
  }
};
